<div [formGroup]="form">
  <div class="search-field">
    <app-ice-search-field placeholder="Søk..." [value]="searchValue" (searchTriggered)="onFilterChange($event)" />
  </div>
  <div class="offering-list-wrapper">
    @for (
      item of allowedMbbOfferingsFiltered | sortBy: 'subscriptionOffering.dataVolume';
      track item.subscriptionOffering.id
    ) {
      @if (item.subscriptionOffering.id !== assignedSubscription?.subscriptionNo) {
        <app-ice-radio-list-item
          testId="mbb-offerings-list-item-input"
          [control]="form.controls.offering"
          [label]="item.subscriptionOffering.name"
          [value]="item.subscriptionOffering.id"
        >
          <div inlineContent>
            <div class="price">
              @if (
                item.subscriptionOffering.monthlyPrice?.isCampaign &&
                item.subscriptionOffering.monthlyPrice?.originalPrice?.includingVAT >
                  item.subscriptionOffering.monthlyPrice?.price?.includingVAT
              ) {
                <span class="mbb-campaign-original-price">
                  {{ item.subscriptionOffering.monthlyPrice.originalPrice | priceFormat: PriceType.OneTime }}
                </span>
              }
              <span class="mbb-monthly-price">
                {{ item.subscriptionOffering.monthlyPrice.price | priceFormat: PriceType.Monthly }}
              </span>
            </div>
          </div>
          <div class="subscription-details" content>
            <div class="mbb-subscription-binding-period">
              @if (item.subscriptionOffering.bindings?.length > 0) {
                <div>{{ item.subscriptionOffering.bindings[0].period }} måneders avtaletid</div>
              } @else {
                <div>ingen avtaletid</div>
              }
            </div>
            @if (
              item.subscriptionOffering.monthlyPrice?.isCampaign &&
              item.subscriptionOffering.monthlyPrice?.campaignPeriod > 0
            ) {
              <app-ice-badge class="campaign-message" type="neutral">
                Rabatt i {{ item.subscriptionOffering.monthlyPrice.campaignPeriod }} måneder
              </app-ice-badge>
            }
            @if (
              assignedSubscription &&
              item.changeInfo?.triggersBreakageFee &&
              item.changeInfo.remainingBreakageFee?.includingVAT > 0
            ) {
              <div class="mbb-breakage-fee-message">
                {{ item.changeInfo.remainingBreakageFee | priceFormat: PriceType.OneTime }} i bruddgebyr
              </div>
            }
          </div>
        </app-ice-radio-list-item>
      }
    }
  </div>
</div>
